import cmsItemsArrayIsEqual from './cmsItemsArrayIsEqual';

export default cmsItemsArrayIsEqual;
